import {
    setAudioEntry,
    pageViewReady,
    audioPlay,
    audioPause,
    audioPlayPre,
    audioPlayNext,
    audioSeekProgress,
    audioStatusShare,
    audioDataUpdate,
    audioClockUpdate,
    audioConditionUpdate,
    audioInsertAfter,
    audioRemovedListUpdate
} from '../util/audio-fn';

class MamaAudio {
    /**
     * 构造函数，创建 MamaAudio 对象
     * @param {Object} options 音频数据
     */
    constructor(options) {
        this.columnId = '';
        this.audioId = '';
        this.index = 0;
        this.currentTime = 0;
        this.status = '';
        this.ext = '';
        this.clockData = {};
        this.conditionData = {};
        this.audioData = {};
        this.options = options || {};

        // 兼容客户端一进来就调用 progress 方法的问题
        window.setAudioProgress = () => {
            // 方
        };
    }

    /**
     * 初始化音频播放器
     * @param {Object} options 音频数据
     */
    init(options) {
        this.getAudioStatus(options);
        this.setAudioData(options);
    }

    /**
     * 设置音频回调函数，通知客户端同步音频状态
     * @param {Object} options 音频数据
     */
    getAudioStatus(options) {
        this.options = {...this.options, ...options};

        window.setAudioIndex = index => {
            this.index = parseInt(index);
            const onIndexChange = options.onIndexChange;
            onIndexChange && onIndexChange(index);
        };

        window.setAudioStatus = status => {
            this.status = status;
            const onStatusChange = options.onStatusChange;
            onStatusChange && onStatusChange(status);
        };

        window.setAudioProgress = second => {
            this.currentTime = second;
            const onProgressChange = options.onProgressChange;
            onProgressChange && onProgressChange(second);
        };

        window.setAudioExt = ext => {
            this.ext = ext;
            const onExtChange = options.onExtChange;
            onExtChange && onExtChange(ext);
        };

        window.setAudioId = id => {
            this.audioId = id;
            const onIdChange = options.onIdChange;
            onIdChange && onIdChange(id);
        };

        window.setAlbumId = window.setColumnId = id => {
            this.columnId = id;
            const onColumnChange = options.onColumnChange;
            onColumnChange && onColumnChange(id);
        };

        window.setAudioClock = clockData => {
            this.clockData = clockData;
            const onClockChange = options.onClockChange;
            onClockChange && onClockChange(clockData);
        };

        window.setAudioCondition = condition => {
            this.conditionData = condition;
            const onConditionChange = options.onConditionChange;
            onConditionChange && onConditionChange(condition);
        };

        window.setAudioData = data => {
            this.audioData = data;
            const onAudioChange = options.onAudioChange;
            onAudioChange && onAudioChange(data);
        };
        window.setRemovedAudioList = data => {
            const onRemovedAudioListChange = options.onRemovedAudioListChange;
            onRemovedAudioListChange && onRemovedAudioListChange(data);
        };
        audioStatusShare();
    }

    /**
     * 配置音频数据
     * @param {Object} options 音频数据
     */
    setAudioData(options) {
        const {columnId, playList} = options;
        if (columnId == undefined) {
            throw new TypeError(`columnId 不能为 ${typeof columnId}`);
        }
        if (!Array.isArray(playList)) {
            throw new TypeError('playList 必须传数组');
        }
        pageViewReady(options);
    }

    /**
     * 更新音频数据
     * @param {Object} options 音频数据
     */
    updateAudioData(options) {
        options = {...this.options, ...options};
        this.options = options;
        audioDataUpdate(options);
    }

    /**
     * 播放特定音频
     * @param {number} index 音频索引
     * @param {string} ext JSON 字符串，自定义内容
     */
    play(index, ext) {
        audioPlay(index, ext);
    }

    /**
     * 播放前一条音频
     * @param {string} ext JSON 字符串，自定义内容
     */
    playPrev(ext) {
        const audioIndex = this.index - 1;
        if (audioIndex >= 0) {
            audioPlayPre(ext);
        }
    }

    /**
     * 播放后一条音频
     * @param {string} ext JSON 字符串，自定义内容
     */
    playNext(ext) {
        const {playList} = this.options;
        const audioIndex = this.index + 1;
        if (audioIndex <= playList.length - 1) {
            audioPlayNext(ext);
        }
    }

    /**
     * 暂停音频播放
     */
    pause() {
        audioPause();
    }

    /**
     * 设置音频进度
     * @param {number} second 秒
     */
    seek(second) {
        audioSeekProgress({index: this.index, currentTime: second});
    }

    /**
     * 设置是否在网页上显示原生音频播放器的入口（默认是显示的）
     * @param {boolean} bool 是否显示
     */
    setPlayerEntry(bool = true) {
        setAudioEntry(bool);
    }

    /**
     * 更新定时数据
     * @param {Object} data 定时参数
     */
    updateClock(data) {
        audioClockUpdate(data);
    }

    /**
     * 更新音频状态数据
     * @param {Object} data 音频状态数据
     */
    updateCondition(data) {
        audioConditionUpdate(data);
    }

    /**
     * 插入一条音频，下一首播放
     * @param {Object} audioData 音频数据
     */
    insertOneAudioAfter(audioData) {
        audioInsertAfter(audioData);
    }

    /**
     * 更新被删除的音频列表
     * @param {string} type 类型
     * @param {Object} audioData 音频数据
     */
    updateRemovedAudioList({type, audioData}) {
        audioRemovedListUpdate({type, audioData});
    }
}

export default new MamaAudio();
